module.exports = "/cyber/_next/static/images/hero-bg-tablet-a96432b944dd3d20b8b49e7fa0372106.jpg";